import { IRenter } from "@/types/renter.type";
import { Modal } from "flowbite-react";
import { FormCreatedSubscription } from "../forms/FormCreatedSubscription";
import { ISubscription } from "@/types/subscription.type";
import { createSubscription } from "@/common/services/subscription.api";
import { useToastContext } from "@/common/components/ui/toast/toast.context";

type Props = {
  renter: IRenter;
  onClose?: () => void;
}

export function ModalCreatedSubscription({ onClose, renter }: Props) {

  const { notifySuccess, notifyError } = useToastContext()

  async function createdSubscription(data: ISubscription) {

    if (!data) {
      notifyError('Dados da assinatura não fornecidos.')
      return { ok: false, errors: [] }; // ✅ Adicionado errors
    }

    try {
      const renterId = renter._id;
      if (!renterId) {
        notifyError('ID do locatário não encontrado.');
        return { ok: false, errors: [{ message: 'ID do locatário não encontrado' }] };
      }

      const result = await createSubscription(data);
      const { ok } = result;

      if (ok) {
        notifySuccess(`Assinatura criada com sucesso!`);
        onClose?.();
        return { ok: true, errors: [] }; // ✅ Adicionado errors: []
      }

      if (!result.ok) {
        notifyError(result.message as string);
      }

      return {
        ok: false,
        errors: [{ message: result.message || "Erro ao criar assinatura" }]
      };
    } catch (err) {
      notifyError('Erro ao tentar criar assinatura, tente novamente')
      return {
        ok: false,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        errors: [{ message: (err as any)?.message || 'Erro desconhecido' }], // ✅ Removido path: []
      }
    }
  }

  return (
    <Modal
      show={true}
      size="5xl"
      onClose={onClose}
    >
      <Modal.Header>
        <h2 className="text-lg font-medium dark:text-black">
          Criar Assinatura para: {renter.name}
        </h2>
      </Modal.Header>
      <Modal.Body>
        {renter ? (
          <FormCreatedSubscription
            onSubmit={createdSubscription}
            renter={renter}
          />
        ) : (
          <p>Carregando...</p>
        )}
      </Modal.Body>
    </Modal>
  )
}